<template>
  <div>
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-if="!loading">
      <div class="container-fluid">
        <div
          v-if="!(message == '' || message == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ message }}</strong>
        </div>
        <div v-else>
          <div class="row" style="margin-bottom: 10px">
            <div class="col-xs-3">
              <h3>Vendors</h3>
            </div>
            <div class="col-xs-6"></div>
            <div class="col-xs-3">
              <img
                :src="BankLogo"
                style="
                  height: 44px;
                  width: 195px;
                  float: right;
                  margin-left: 20px;
                "
              />
            </div>
          </div>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control search-box"
              style="background-color: white"
              placeholder="Search"
              v-model="Search"
            />
            <button
              class="btn btn-primary"
              @click="ChangePageSizeORSearch"
              style="margin-left: 4px"
            >
              Search
            </button>
            <button
              class="btn btn-primary"
              @click="ExportCSV"
              style="margin-left: 4px"
            >
              Export to CSV
            </button>
            <button
              class="btn btn-primary"
              style="margin-left: 4px"
              @click="Print"
            >
              Print
            </button>
            <div class="pull-right">
              <button class="btn btn-primary" @click="AddVendor">
                Add Vendor
              </button>
            </div>
          </div>
          <div v-bind:id="'printable'">
            <table class="table table-bordered ng-grid">
              <thead style="background: #efeeed">
                <tr>
                  <th>No.</th>

                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Name')"
                      >Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Name'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Type')"
                      >Type</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Type'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Address')"
                      >Address</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Address'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('ContactNo')"
                      >Contact No</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'ContactNo'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th class="Print">Commodities</th>
                  <th class="Print">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(vendor, index) in OrderBy"
                  :key="index"
                  :class="{ even: index + (1 % 2) == 0 }"
                >
                  <td>
                    {{
                      (SelectedPageSize == "ALL" ? 0 : SelectedPageSize) *
                        (currentPage - 1) +
                      (index + 1)
                    }}
                  </td>
                  <td>{{ vendor.Name }}</td>
                  <td>{{ vendor.Type }}</td>
                  <td>{{ vendor.Address }}</td>
                  <td>{{ vendor.ContactNo }}</td>
                  <td align="center" class="Print">
                    <a
                      href="javascript:void(0)"
                      @click="setBackUrl(vendor.Id)"
                      title="Add/Remove"
                    >
                      <i class="glyphicon glyphicon-tint lg"></i>
                    </a>
                  </td>
                  <td class="img Print">
                    <a
                      href="javascript:void(0)"
                      title="Edit Vendor"
                      @click="EditVendor(vendor.Id)"
                    >
                      <img src="../../assets/imgs/png/Action.png" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="custom-width">
            <div class="pull-left">
              <paginate
                ref="paginate"
                :page-count="PageCalculation"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :click-handler="clickCallback"
                :container-class="'pagination'"
              ></paginate>
            </div>
            <div class="btn-group form-inline pull-right pager">
              <label>Page Size :</label>
              <select
                v-model="SelectedPageSize"
                class="form-control input-sm"
                @change="ChangePageSizeORSearch"
              >
                <option v-for="(option, index) in PageSize" :key="index">
                  {{ option.key }}
                </option>
              </select>
            </div>
          </div>
          <pre class="custom-width">
Page:{{ currentPage }} / {{ PageCalculation }} </pre
          >
        </div>
      </div>
    </div>
    <vendor v-if="showModal" @Close="closeModal" :VendorId="VendorId"></vendor>
  </div>
</template>


<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import Vendor from "./Vendor";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      currentPage: 1,
      showModal: false,
      VendorId: null,
      Search: null,
      currentSort: "Name",
      curentSortOrder: "asc",
    };
  },
  components: {
    Vendor,
  },
  methods: {
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function (page) {
      if (page) {
        this.currentPage = page;
        this.ChnageUrl();
        this.GetData();
      }
    },

    ChnageUrl() {
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort;
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },

    Print() {
      this.printData("printable", "Vendor");
    },
    AddVendor() {
      this.showModal = true;
    },
    GetData() {
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search);

      var vm = this;
      this.$store
        .dispatch(ACTIONS.VENDORS_GETALL, Url)
        .then((res) => {
          this.$refs.paginate.selected = vm.currentPage - 1;
        })
        .catch((err) => {});
    },
    setBackUrl(key) {
      this.$router.push({ path: "VendorCommodities/" + key });
    },
    EditVendor(id) {
      this.VendorId = id;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.VendorId = null;
      this.GetData();
    },
    ExportCSV() {
      this.ObjectToCSV(
        "Vendors.csv",
        this.VendorData,
        ["Name", "Type", "Address", "ContactNo"],
        ["Name", "Type", "Address", "Contact Number"]
      );
    },
  },

  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
    }

    this.GetData();
  },

  computed: {
    ...mapGetters({
      PageSize: "PageSize",
      VendorData: "VendorData",
      TotalRecords: "TotalPages",
      message: "errorMessage",
      loading: "Vendorloading",
      BankLogo: "GETBANKLOGO",
    }),
    OrderBy() {
      var data = [...this.VendorData];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      if (!this.SelectedPageSize || this.SelectedPageSize == "ALL") {
        this.SelectedPageSize = SortedArray.length;
      }
      if (!this.currentPage) {
        this.currentPage = 1;
      }
      var sp = parseInt(this.SelectedPageSize); // selected Page
      var cp = parseInt(this.currentPage); // current page
      // var _pageData = this.Pagination(SortedArray, sp, cp);
      return this.Pagination(SortedArray, sp, cp);
    },
    PageCalculation() {
      var count = Math.ceil(this.TotalRecords / this.SelectedPageSize);
      return count > 0 ? count : 1;
    },
  },
};
</script>

